<app-navigation
  class="pcoded-navbar"
  [ngClass]="{
    'navbar-collapsed': navCollapsed,
    'mob-open': navCollapsedMob
  }"
  (onNavMobCollapse)="navMobClick()"
></app-navigation>
<app-nav-bar
  class="navbar pcoded-header navbar-expand-lg navbar-light"
  (onNavCollapse)="this.navCollapsed = !this.navCollapsed"
  (onNavHeaderMobCollapse)="navMobClick()"
></app-nav-bar>
<div class="pcoded-main-container">
  <div class="pcoded-wrapper">
    <div class="pcoded-content">
      <div class="pcoded-inner-content">
        <div class="main-body">
          <div class="page-wrapper">
            <app-breadcrumb></app-breadcrumb>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-configuration></app-configuration>
